import React, { useEffect, useState, useContext } from 'react';
import DropDown from '../Reutilizaveis/DropDown';
import DropDownDisabled from '../Reutilizaveis/DropDownDisabled';
import Fade from '@material-ui/core/Fade';
import Documentos from './Documentos';
import Videos from './Videos';
import Noticias from './Noticias';
import EtapasDoRegistro from './EtapasResgistro';
import LinhaDoTempo from './LinhaDoTempo';
import { montaListaImoveis, returnImovelSelecionado } from './controler';
import HeaderStroke from '../HeaderStroke';
import { Spinner } from '../StyledComponent';
import { ContextNotificacoes } from '../../services/notificacoes';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';
// import { useHistory } from "react-router-dom";
import { ReactComponent as DocumentosIcon } from '../../assets/novosicones/MeuImovel/menu/Documentos.svg';
// import { ReactComponent as EtapasRegistro } from '../../assets/novosicones/MeuImovel/menu/EtapasRegistro.svg';
import { ReactComponent as LinhaTempo } from '../../assets/novosicones/MeuImovel/menu/LinhaTempo.svg';
import { ReactComponent as VideosIcon } from '../../assets/novosicones/MeuImovel/menu/Videos.svg';

import { getImoveis } from '../../services/meuImovel';

import './styles.scss';

const MeuImovelComponent = ({ imovelId, videoId, noticiaId, documentos }) => {
  const [meusImoveis, setMeusImoveis] = useState([]);

  const [imovelSelecionado, setImovelSelecionado] = useState('');

  const [
    idEmpreendimentoImovelSelecionado,
    setIdEmpreendimentoImovelSelecionado,
  ] = useState('');

  const [idOportunidade, setIdOportunidade] = useState('');

  const [dadosImovel, setDadosImovel] = useState({});

  const [showVideos, setShowVideos] = useState(false);

  const [showDocumentos, setShowDocumentos] = useState(false);

  const [showTimeLine, setShowTimeLine] = useState(false);

  const [showEtapas, setShowEtapas] = useState(false);

  const [dadosImovelSelecionado, setDadosImovelSelecionado] = useState([]);

  const [statusImovel, setStatusImovel] = useState('');

  const [initialLoading, setInitialLoading] = useState(true);

  const { CHECKIFNOTIFICATION } = useContext(ContextNotificacoes);

  const { tema } = useContext(ContextoListaApartamentos);
  // const history = useHistory();

  useEffect(() => {
    CHECKIFNOTIFICATION();
  }, [imovelId, videoId, noticiaId]);

  useEffect(() => {
    (async function () {
      await loadMeusImoveis();
    })();
  }, []);

  useEffect(() => {
    if (imovelSelecionado != '') {
      resetShowStates();
      setDadosImovel({});
      removeActiveInactive();

      (async function () {
        await loadDadosImovel();
      })();
    } else {
      setDadosImovel({});
    }
    // history.replace(location.state, undefined);
  }, [imovelSelecionado]);

  useEffect(() => {
    if (dadosImovelSelecionado.length > 0) {
      loadDadosMeuImovel();
      getIdContrato();
    }
  }, [dadosImovelSelecionado]);

  useEffect(() => {
    if (meusImoveis.length > 0) {
      if (imovelId) {
        const imovelRedirected = meusImoveis.find((imovel) => {
          return imovel.empreendimentoId == imovelId;
        });
        if (imovelRedirected) setImovelSelecionado(imovelRedirected.nome);
        else setImovelSelecionado(meusImoveis[0].nome);
      } else setImovelSelecionado(meusImoveis[0].nome);
    }
  }, [meusImoveis]);

  async function loadMeusImoveis() {
    let resultImoveis = await getImoveis();
    setMeusImoveis(await montaListaImoveis(resultImoveis));
    setInitialLoading(false);
    if (videoId) {
      setShowVideos(true);
      setItemMenuActive('Vídeos');
    } else if (documentos) {
      setShowDocumentos(true);
      setItemMenuActive('Documentos');
    }
  }

  // carrega todos dados do imóvel selecionado
  async function loadDadosImovel() {
    if (imovelSelecionado != '') {
      setDadosImovelSelecionado(
        await returnImovelSelecionado(meusImoveis, imovelSelecionado)
      );
    }
  }

  function loadDadosMeuImovel() {
    setDadosImovel({
      nome: dadosImovelSelecionado[0].nome,
      numeroContrato:
        dadosImovelSelecionado[0].contratos[0].contratoIdSalesforce,
      tipoDeUnidade: dadosImovelSelecionado[0].nome.split(' ')[0],
      numero: dadosImovelSelecionado[0].numero,
      entregaChaves: dadosImovelSelecionado[0].entregaChaves.split('T')[0],
      vistoria: dadosImovelSelecionado[0].vistoria,
      tipoEmpreendimento: dadosImovelSelecionado[0].tipoEmpreendimento,
      oportunidadeIdSalesForce:
        dadosImovelSelecionado[0].oportunidadeIdSalesForce,
    });
    setStatusImovel(dadosImovelSelecionado[0].contratos[0].status);

    if (dadosImovelSelecionado[0].contratos[0].status == 'Distratado') {
      resetShowStates();
      setShowDocumentos(true);
    }
  }

  function getIdContrato() {
    setIdEmpreendimentoImovelSelecionado(
      dadosImovelSelecionado[0].empreendimentoId
    );
    setIdOportunidade(dadosImovelSelecionado[0].oportunidadeIdSalesForce);
  }

  function resetShowStates() {
    setShowEtapas(false);
    setShowDocumentos(false);
    setShowTimeLine(false);
    setShowVideos(false);
  }

  function setItemMenuActive(itemSelecionado) {
    addCorMenu(itemSelecionado);
    let itensMenuSeletor = Array.from(
      document.getElementsByClassName('meuImovel__seletor__btnSeletor')
    );
    itensMenuSeletor.forEach((itemMenu) => {
      itemMenu.classList.remove('meuImovel__seletor__btnSeletor--active');
      itemMenu.classList.remove('meuImovel__seletor__btnSeletor--inactive');
      if (itemMenu.innerText == itemSelecionado) {
        itemMenu.classList.add('meuImovel__seletor__btnSeletor--active');
      } else {
        itemMenu.classList.add('meuImovel__seletor__btnSeletor--inactive');
      }
    });
  }

  function removeActiveInactive() {
    let itensMenuSeletor = Array.from(
      document.getElementsByClassName('meuImovel__seletor__btnSeletor')
    );
    itensMenuSeletor.forEach((itemMenu) => {
      itemMenu.classList.remove('meuImovel__seletor__btnSeletor--inactive');
    });
  }

  function addCorMenu(itemSelecionado) {
    let iconesMenu = Array.from(
      document.getElementsByClassName('iconeMenuSeletor')
    );

    iconesMenu.forEach((item) => {
      item.classList.remove('meuImovel__seletor__btnSeletor--active');
      item.classList.remove('meuImovel__seletor__btnSeletor--inactive');

      if (item.attributes.name.value == itemSelecionado) {
        item.classList.add('meuImovel__seletor__btnSeletor--active');
      } else {
        item.classList.add('meuImovel__seletor__btnSeletor--inactive');
      }
    });
  }

  // var corEmpreendimento = "";
  // if (dadosImovel.tipoEmpreendimento == "DIRECIONAL ENGENHARIA S.A.")
  //   corEmpreendimento = "#003da5";
  // else corEmpreendimento = "#1D3054";

  if (initialLoading) return <Spinner />;

  return (
    <Fade in>
      <div className='meuImovel'>
        <HeaderStroke name={'Meu Imóvel'} />
        <div className='containerMeuImovel'>
          <div className='containerMeuImovel__inner'>
            {meusImoveis.length == 0 && <h1>Sem imóveis disponíveis</h1>}
            {meusImoveis.length > 0 && (
              <>
                {meusImoveis.length == 1 ? (
                  <DropDownDisabled
                    obrigatorio={true}
                    nomeDropDown={'Imóvel'}
                    largura={'calc(100% - 4px)'}
                    margin='0'
                  >
                    {meusImoveis[0].nome}
                  </DropDownDisabled>
                ) : (
                  <DropDown
                    itens={meusImoveis}
                    idDropDown={'Listaimoveis'}
                    setValue={setImovelSelecionado}
                    label='Imóvel'
                    nomeDropDown='SELECIONE O IMÓVEL DESEJADO'
                    overflow='hidden'
                    alturaMinima='120px'
                    widthMeuImovel='100%'
                    marginLeftMeuImovel='0px'
                    obrigatorio='true'
                    nomeSelecionado={imovelSelecionado}
                  />
                )}
                <div
                  className='meuImovel__seletor centralized-space-evenly'
                  style={{ width: '100%' }}
                >
                  <button
                    disabled={imovelSelecionado == '' ? true : false}
                    className='meuImovel__seletor__btnSeletor centralized'
                    onClick={() => {
                      resetShowStates();
                      setShowDocumentos(true);
                      setItemMenuActive('Documentos');
                    }}
                    style={{ color: tema.primaryColor }}
                    id='btnMeuImovelDocumentos'
                  >
                    <span>
                      <DocumentosIcon style={{ fill: tema.primaryColor }} />
                    </span>
                    <span>Documentos</span>
                  </button>
                  {/* <div className="meuImovel__seletor__divisor"></div>
                  <button
                    className="meuImovel__seletor__btnSeletor centralized"
                    disabled={
                      statusImovel == "Distratado" || imovelSelecionado == ""
                        ? true
                        : false
                    }
                    style={{
                      visibility:
                        statusImovel == "Distratado" ? "hidden" : "visible",
                      transition: "0.3s",
                      color: tema.primaryColor,
                    }}
                    onClick={() => {
                      resetShowStates();
                      setShowEtapas(true);
                      setItemMenuActive("Etapas do registro");
                    }}
                    id="btnMeuImovelEtapasDoRegistro"
                  >
                    <EtapasRegistro style={{ fill: tema.primaryColor }} />
                    Etapas do registro
                  </button> */}
                  <div className='meuImovel__seletor__divisor'></div>
                  <button
                    className='meuImovel__seletor__btnSeletor centralized'
                    disabled={
                      statusImovel == 'Distratado' || imovelSelecionado == ''
                        ? true
                        : false
                    }
                    style={{
                      visibility:
                        statusImovel == 'Distratado' ? 'hidden' : 'visible',
                      transition: '0.3s',
                      color: tema.primaryColor,
                    }}
                    onClick={() => {
                      resetShowStates();
                      setShowTimeLine(true);
                      setItemMenuActive('Linha do tempo');
                    }}
                    id='btnMeuImovelLinhaDoTempo'
                  >
                    <LinhaTempo style={{ fill: tema.primaryColor }} />
                    Linha do tempo
                  </button>{' '}
                  <div className='meuImovel__seletor__divisor'></div>
                  <button
                    className='meuImovel__seletor__btnSeletor centralized'
                    disabled={
                      statusImovel == 'Distratado' || imovelSelecionado == ''
                        ? true
                        : false
                    }
                    style={{
                      visibility:
                        statusImovel == 'Distratado' ? 'hidden' : 'visible',
                      transition: '0.3s',
                      color: tema.primaryColor,
                    }}
                    onClick={() => {
                      resetShowStates();
                      setShowVideos(true);
                      setItemMenuActive('Vídeos');
                    }}
                    id='btnMeuImovelVideos'
                  >
                    <VideosIcon style={{ fill: tema.primaryColor }} />
                    Vídeos
                  </button>
                </div>
                <div className='meuImovel__selecionado'>
                  <div>
                    {showDocumentos && (
                      <Documentos
                        idEmpreendimentoImovelSelecionado={
                          idEmpreendimentoImovelSelecionado
                        }
                        numeroContrato={dadosImovel.numeroContrato}
                        corEmpreendimento={tema.primaryColor}
                        statusImovel={statusImovel}
                        oportunidadeIdSalesForce={
                          dadosImovel.oportunidadeIdSalesForce
                        }
                      />
                    )}
                  </div>

                  {showEtapas && (
                    <Fade in>
                      <EtapasDoRegistro
                        idOportunidade={idOportunidade}
                        corEmpreendimento={tema.primaryColor}
                      />
                    </Fade>
                  )}

                  {showTimeLine && (
                    <Fade in>
                      <LinhaDoTempo
                        idEmpreendimentoImovelSelecionado={
                          idEmpreendimentoImovelSelecionado
                        }
                        corEmpreendimento={tema.primaryColor}
                      />
                    </Fade>
                  )}

                  {showVideos && (
                    <Fade in>
                      <Videos
                        idEmpreendimentoImovelSelecionado={
                          idEmpreendimentoImovelSelecionado
                        }
                        videoId={videoId}
                      />
                    </Fade>
                  )}
                </div>
                {statusImovel != 'Distratado' && imovelSelecionado != '' && (
                  <Fade>
                    <Noticias
                      idEmpreendimentoImovelSelecionado={
                        idEmpreendimentoImovelSelecionado
                      }
                      tipoEmpreendimento={dadosImovel.tipoEmpreendimento}
                      noticiaId={noticiaId}
                    />
                  </Fade>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default MeuImovelComponent;
